import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AmountDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/amount-dto';
import { OpkraevningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opkraevning-dto';
import { PriceComponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/price-component-dto';
import { PriceDialogData } from '../models';

@Component({
    selector: 'app-price-dialog',
    templateUrl: './price-dialog.component.html',
    styleUrls: ['./price-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PriceDialogComponent implements OnInit {
  priceComponents: PriceComponentDto[];
  moms: boolean;
  totalPrice: AmountDto;
  listPrice: AmountDto;
  opkraevning: OpkraevningDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: PriceDialogData) {}

  ngOnInit(): void {
    this.priceComponents = this.data.pricecomponents;
    this.moms = this.data.moms;
    this.totalPrice = this.data.totalPrice;
    this.listPrice = this.data.listPrice;
    this.opkraevning = this.data.opkraevning;
  }
}
